module.exports = __webpack_public_path__ + "img/icon2.0b849820.png";